import * as React from 'react';

export const ArrowTopLeftWithBackground: React.FunctionComponent<{}> = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask492392349"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="12"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 2H2V14H14V2ZM10 6.5H7.56671L11.3604 10.2937L10.2997 11.3544L6.5 7.55461V10H5V6.5V5H6.5L10 5V6.5Z"
          fill="#666666"
        />
      </mask>
      <g mask="url(#mask492392349)">
        <rect width="16" height="16" fill="#CCCCCC" />
      </g>
    </svg>
  );
};
